export default {"src":"/_next/static/media/exploring.mono.1a1028fd.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};